import React, {useRef, useEffect} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space} from 'antd';
import {getAll, drop} from '../../../../apis/CalculosApi';
import {type_period} from '@app/constants/period';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catalogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <ClockCircleFilled />
        <span>Definicion de Poliza</span>
      </>
    ),
}];

const ParametrosPage = () => {
    const [items, setItems] = React.useState([]);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [periodSelected, setPeriodSelected] = React.useState(null);

    const columns = [
      {
        title: 'Clave',
        dataIndex: 'clave',
        key: 'clave',
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setPeriodSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la definición?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡La definición ha sido eliminado!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setPeriodSelected(null);
    }

    const onHandlerFinish = async (refresh,  avoidClose) => {
      if(!avoidClose){
        setOpenEdit(false);
      }

      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    
    return <PageApp routes={routes}>
      <Button type="primary" onClick={btnClick}>
          Agregar Definición
      </Button>
      <Divider/>
      {
          items.length == 0 ? <Empty />:
          <Table dataSource={items} columns={columns} />
      }
      {
        (openEdit && periodSelected && periodSelected.id > 0) &&
        <ModalEdit title={"Editar Definición"} id={periodSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !periodSelected) &&
        <ModalEdit title={"Crear Definición"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default ParametrosPage;
